import axios from 'axios';

const authHeaders = token => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const login = async ({ email, password }) => {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
    email,
    password,
  });
  return res?.data || {};
};

export const register = async ({ email, username, password }) => {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, {
    email,
    username,
    password,
  });
  return res?.data || {};
};

export const getMe = async token => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/auth/me`,
    authHeaders(token),
  );
  return res?.data || {};
};

export const updateProfile = async ({
  username,
  avatarUrl,
  descriptionMarkdown,
}) => {
  const token = window.localStorage.getItem('auth_token');
  const res = await axios.patch(
    `${process.env.REACT_APP_API_URL}/auth/profile`,
    {
      username,
      avatarUrl,
      descriptionMarkdown,
    },
    authHeaders(token),
  );
  return res?.data || {};
};

export const getDiscordAuthUrl = async ({ mode = 'login', returnTo = '/profile' } = {}) => {
  const token = window.localStorage.getItem('auth_token');
  const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/discord/start`, {
    params: { mode, returnTo },
    ...(token ? authHeaders(token) : {}),
  });
  return res?.data || {};
};

export const unlinkDiscordAccount = async () => {
  const token = window.localStorage.getItem('auth_token');
  const res = await axios.delete(
    `${process.env.REACT_APP_API_URL}/auth/discord/link`,
    authHeaders(token),
  );
  return res?.data || {};
};

export const getAccountDeletionPreview = async () => {
  const token = window.localStorage.getItem('auth_token');
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/auth/me/deletion-preview`,
    authHeaders(token),
  );
  return res?.data || {};
};

export const deleteUserAccount = async ({ universes } = {}) => {
  const token = window.localStorage.getItem('auth_token');
  const res = await axios.delete(
    `${process.env.REACT_APP_API_URL}/auth/me`,
    {
      ...authHeaders(token),
      data: { universes },
    },
  );
  return res?.data || {};
};

export const requestPasswordReset = async ({ email }) => {
  const endpoints = ['/auth/forgot-password', '/auth/forgot'];
  let lastError = null;

  for (const endpoint of endpoints) {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}${endpoint}`, {
        email,
      });
      return res?.data || {};
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404 || status === 405) {
        lastError = error;
        continue;
      }
      throw error;
    }
  }

  if (lastError) {
    const unsupported = new Error('password_reset_unsupported');
    unsupported.code = 'PASSWORD_RESET_UNSUPPORTED';
    throw unsupported;
  }

  return {};
};

export const resetPassword = async ({ token, password }) => {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/reset-password`, {
    token,
    password,
  });
  return res?.data || {};
};
